import React, { createContext, useContext, useState } from 'react';

const NavGuardContext = createContext(null);

export function NavGuardProvider({ children }) {
  const [proposalOutlineCritical, setProposalOutlineCritical] = useState(false);
  const [lessonPlanCritical, setLessonPlanCritical] = useState(false);
  return (
    <NavGuardContext.Provider
      value={{
        proposalOutlineCritical,
        setProposalOutlineCritical,
        lessonPlanCritical,
        setLessonPlanCritical,
      }}
    >
      {children}
    </NavGuardContext.Provider>
  );
}

export function useNavGuard() {
  const ctx = useContext(NavGuardContext);
  if (!ctx) {
    return {
      proposalOutlineCritical: false,
      setProposalOutlineCritical: () => {},
      lessonPlanCritical: false,
      setLessonPlanCritical: () => {},
    };
  }
  return ctx;
}
